import { Component, inject, OnInit, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { WishlistService, WishlistItem } from '../services/wishlist.service';
import { CartService } from '../services/cart.service';
import { ToastService } from '../services/toast.service';
import { Product } from '../models/admin.models';
import { NavbarComponent } from '../shared/navbar/navbar.component';
import { AuthService } from '../services/auth.service';
import { take, map, switchMap, of } from 'rxjs';

@Component({
  selector: 'app-wishlist',
  standalone: true,
  imports: [CommonModule, RouterLink, NavbarComponent],
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.scss']
})
export class WishlistComponent {
  protected wishlistService = inject(WishlistService);
  private cartService = inject(CartService);
  private toastService = inject(ToastService);
  private authService = inject(AuthService);

  wishlistItems = this.wishlistService.getWishlistSignal();
  
  // Computed signal to extract products from wishlist items
  wishlist = computed(() => this.wishlistItems().map(item => item.product));

  getImageUrl(image: string): string {
    if (!image) return '/assets/placeholder-botanical.jpg';
    return image.startsWith('http') ? image : '/' + image;
  }

  getDiscountedPrice(product: Product): number {
    if (!product.discount) return product.price;
    return product.price * (1 - product.discount / 100);
  }

  addToCart(product: Product) {
    this.cartService.addToCart(product, 1);
    this.toastService.success(`${product.name} added to your ritual!`);
  }

  removeFromWishlist(product: Product) {
    this.authService.userProfile$.pipe(
      take(1),
      map(user => user?.uid),
      switchMap(uid => {
        if (!uid) return of(null);
        this.wishlistService.removeFromWishlist(uid, product.id);
        this.toastService.success('Removed from wishlist');
        return of(true);
      })
    ).subscribe();
  }
}
